export default "__VITE_ASSET__3OaAetJf__"